module.exports = __webpack_public_path__ + "dash_20_app_assets/img/automate.8a87354b.png";